import { render, staticRenderFns } from "./TheSearchForm.vue?vue&type=template&id=567d2ad0&"
import script from "./TheSearchForm.vue?vue&type=script&lang=js&"
export * from "./TheSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567d2ad0')) {
      api.createRecord('567d2ad0', component.options)
    } else {
      api.reload('567d2ad0', component.options)
    }
    module.hot.accept("./TheSearchForm.vue?vue&type=template&id=567d2ad0&", function () {
      api.rerender('567d2ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheSearchForm.vue"
export default component.exports